import { useSnapshot } from 'valtio';
import { AppStore } from '../store/store';
import { FaChevronRight, FaChevronLeft } from "react-icons/fa6";
import { useStoreActions } from '../store/actions';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import cls from '../styles/Main.module.scss';

const Main = () => {
  const { toggleSelectedObject, onHoverOverObject } = useStoreActions()
  const { selectedObject } = useSnapshot(AppStore);

  const onNextPage = (selectedObject: 'А' | 'Б') => {
    AppStore.selectedObject = selectedObject;
    AppStore.currentPage = selectedObject === 'А' ? 21 : 22;
  };

  return (
    <div className={cls.mainContainer}>
      <div className={cls.infoContainer}>
        <div className={cls.selectionScreen}>
          <div className={cls.selectionBody}>
            <button className={cls.arrowButton} onClick={toggleSelectedObject}>
              <FaChevronLeft />
            </button>
            <div className={cls.selectedBlock}>
              <p>Блок</p>
              <p>{selectedObject}</p>
            </div>
            <button className={cls.arrowButton} onClick={toggleSelectedObject}>
              <FaChevronRight />
            </button>
          </div>
        </div>

        <div className={cls.detailsContainer}>
          <div className={cls.detailItem}>
            <div>Объект:</div>
            <div>Vinchi»</div>
          </div>
          <div className={cls.detailItem}>
            <div>Этажей:</div>
            <div>15</div>
          </div>
          <div className={cls.detailItem}>
            <div>Количество квартир:</div>
            <div>104</div>
          </div>
          <div className={cls.detailItem}>
            <div>Адрес:</div>
            <div>Бишкек, мкрн Асанбай</div>
          </div>
        </div>

        <button onClick={() => onNextPage(selectedObject)} className={cls.selectButton}>
          Выбрать
        </button>
      </div>

      <div className={cls.imageContainer}>
        <svg viewBox="0 0 907.20001 644.79999">
          <path
            id="object_a"
            className={cls.objectA}
            onClick={() => onNextPage('А')}
            onMouseOver={() => onHoverOverObject('А')}
            fill="#3292ffcc"
            d="m 134.79147,252.99171 134.48392,-90.76006 6.73362,3.6792 20.54795,-13.95317 -2.01314,-1.1107 63.86526,-42.55371 1.94373,0.90245 6.38652,-3.54036 -5.5535,-2.36024 12.14829,-8.8856 0.0694,-0.902444 2.36024,-1.249538 100.86547,48.593132 8.05257,-5.90059 -0.97186,-0.55535v -1.24954l -4.09571,-2.08256 12.5648,-9.44095 -13.08544,237.23862 -8.27818,8.17406 0.0712,11.07879 -13.49878,12.36979 -0.0491,19.04555 -7.80475,5.89038 3.28879,1.96346 -4.9329,4.40608 -0.13884,10.55165 1.94373,1.04129 -0.13884,0.55535 -0.48593,0.34709 v 2.56849l -20.68679,18.95133 -14.50853,-8.8856 -27.90634,23.39412 4.02629,2.84617 -4.72048,4.02629 0.13884,10.62107 2.15198,1.24954 -0.90244,0.62476 0.0694,2.77675 -9.51037,8.60793 1.18011,0.76361 -0.0694,0.48593 -0.41652,0.27767 -0.0694,1.31896 0.41652,0.41651 v 0.48593 l -5.97002,5.27583 0.0694,4.51222 5.20641,3.47094 -0.0694,0.48593 -0.83302,0.34709v 2.98501l -9.64921,9.02444 -1.38838,-1.38837 -17.07701,15.34154 0.0694,2.29082 -10.13513,9.37153 -1.4578,-1.31895 -17.28527,15.41096v 2.77675l -10.27398,9.16328 -32.83507,-22.83877 -5.48409,4.51222 0.0694,0.7636 -1.59663,1.24954 -20.41043,-14.2714 -17.22935,15.21681 -48.74287,-33.86967 16.44397,-13.54787 -9.17917,-6.77394 -0.0982,-0.83447 -1.47259,-1.32533 -13.10609,-8.3447 -1.71803,-15.51133 -2.06163,-1.4726 0.0491,-0.68721 -1.32534,-0.88355 -0.0982,-1.27625 8.24653,-6.43033 -5.64495,-45.99403 -4.3687,-2.65067 -0.19634,-0.83447 0.39269,-0.24543 -0.0982,-0.53995 -1.42351,-0.93265 -0.0491,-0.93264 4.02509,-3.14154 0.29452,-0.83447 -6.8721,-53.01339 -3.97601,-1.96346 -0.14726,-1.03082 0.7363,-0.0491 -0.14726,-1.12899 -1.03082,-0.68721 0.0982,-0.63813 3.2397,-2.40524 -7.51023,-59.00194 -4.66321,-2.60159 -0.0491,-0.73629 0.49087,-0.14726 0.19634,-0.53996 -1.91437,-1.17807v -0.83447l 2.74884,-1.86529 -1.47259,-12.36979 -1.91438,-0.98173 -0.0491,-0.63812 -0.7363,-0.14726v -0.78539l 2.45432,-1.76711 -1.66894,-13.7933z"
          />

          <path
            id="object_b"
            className={cls.objectB}
            onClick={() => onNextPage('Б')}
            onMouseOver={() => onHoverOverObject('Б')}
            fill="#3292ffcc"
            d="m 377.91575,90.660906 92.35726,-61.380821 255.56091,110.763595 -0.13016,1.87431 10.00439,4.4088 -0.0491,0.53996 -15.02046,12.86065 -1.8162,10.74994 2.69976,1.17808 -0.0491,0.93264 -2.60158,2.25798 -2.01255,12.02619 1.76711,1.03081 -0.0491,0.98173 -1.42351,1.37442 0.19635,1.52168 -1.96346,1.37443 -10.94629,60.2291 1.96346,0.88356 -0.14726,0.98173 -1.22716,1.03082v 0.53995l 0.44178,0.53995 -0.19635,0.34361 -2.1598,1.71802 -10.01365,55.71316 1.91438,0.93264 -0.19635,0.98173 -1.32533,1.03081 -0.0491,0.29452 0.34361,0.24544 -0.0491,0.53995 -1.66894,1.4235 -9.57186,51.04994 5.0559,2.5525 -2.79793,17.72022 -72.84433,72.2553 -50.16638,-30.04093 -11.38807,11.38806 -27.04424,-15.73731 0.0694,-3.22797 1.75283,-1.52721 0.77694,-9.15574 -32.98612,-18.94738 1.17808,-19.2419 -23.65968,-13.15518 8.59013,-7.95201 13.80357,-235.32431 -12.9466,9.54508 3.78332,2.18669 -0.17355,0.7289 1.14541,0.86773 -7.20746,4.73916"
          />

          <circle className={cls.symbolsA} cx="250" cy="130" r="40" fill="#333333" />
          <text className={cls.symbolsA} x="250" y="120" fontSize="14" textAnchor="middle" fill="white">Блок</text>
          <text className={cls.symbolsA} x="250" y="145" fontSize="24" textAnchor="middle" fill="white">А</text>

          <circle className={cls.symbolsB} cx="630" cy="50" r="40" fill="#333333" />
          <text className={cls.symbolsB} x="630" y="40" fontSize="14" textAnchor="middle" fill="white">Блок</text>
          <text className={cls.symbolsB} x="630" y="65" fontSize="24" textAnchor="middle" fill="white">Б</text>
        </svg>
        <LazyLoadImage src="./images/structure.png" alt="" effect="blur" />
      </div>
    </div>
  );
};

export default Main;
